export default "__VITE_ASSET__fea658b2__"